import React from "react";
import SEO from "../shared/seo";
import Layout from "../shared/components/organisms/layout/layout"
import '../shared/styles/index.scss'
import ConsultingContent from "../components/organisms/consulting-content/consulting-content";
import Helmet from "react-helmet"

class IndexPage extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      mobile: false,
     };
  }

  componentDidMount() {
    if (window.innerWidth < 1024) {
      this.setState(
        { 
          mobile: true
        }
      );
    }
    window.addEventListener("resize", this.updateDimensions);
    
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  
  updateDimensions=()=> {
    if (window.innerWidth < 1024){
      this.setState(
        { 
          mobile: true
        }
      )
    }else{
      this.setState(
        { 
          mobile: false
        }
      );
    }
  }

  render() {
    return (
      <Layout
        mobile={this.state.mobile} 
        title={this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaTitulo} 
      >

        <SEO 
          title={this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaTitulo} 
          description={this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaDescripcion?.metaDescripcion.split("\n")[0]}
          url={"/entre-nosotras/consultorios/"}
        />
        <ConsultingContent mobile={this.state.mobile} params={this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]}/>

      </Layout>
    )
  }

}
export const query = graphql`

    query GET_CONSULTING_CONTENT($locale: String!){
      allContentfulNolHomeTercerNivel(filter: {node_locale: {eq: $locale}, slug: {in: ["consultorios", "consultorios/"]}}) {
        nodes {
          slug
          titulo
          metaTitulo
          metaDescripcion {
            metaDescripcion
          }
          banner {
            bannerSecciones {
              file {
                url
                details {
                  image {
                    height
                  }
                }
              }
              fluid(maxWidth: 1920, quality: 100) {
                sizes
                src
                srcSet
                srcSetWebp
                srcWebp
              }
              description
              fixed {
                base64
              }
            }
          }
          informacionAdicionalConsultorios {
            json
          }
          consultorios {
            ... on ContentfulNolConsultorios {
              slug
              titulo
              descripcionDelConsultorio {
                descripcionDelConsultorio
              }
              imagenMiniatura {
                description
                file {
                  url
                }
              }
            }
          }
        }
      }
    }

`

export default IndexPage